import { useEffect, useMemo, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchSpeakers } from '@/store/slices/speakers';
import { selectSpeakers } from '@/store/slices/speakers/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';

type TUseLoadSpeakers = {
  skipIfSpeakersExist?: boolean;
};

const useLoadSpeakers = (props?: TUseLoadSpeakers) => {
  const { skipIfSpeakersExist } = props || {};

  const channel = useAppSelector(getActiveChannel);
  const speakers = useAppSelector(selectSpeakers);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  const shouldReturnEarly = useMemo(() => {
    return skipIfSpeakersExist && speakers;
  }, [skipIfSpeakersExist, speakers]);

  useEffect(() => {
    if (!channel || fetched.current || shouldReturnEarly) {
      return;
    }
    fetched.current = true;
    dispatch(fetchSpeakers({ channel, returnStoreStateIfExists: true }));
  }, [channel, dispatch, shouldReturnEarly]);
};

export default useLoadSpeakers;
